import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-950 text-background-50">
      <div className="px-6 md:px-10 pt-16 pb-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            <div className="md:col-span-1">
              <span className="text-xl font-heading font-semibold text-background-50">
                Hoobuy <span className="text-primary-400">Sheet</span>
              </span>
              <p className="mt-4 text-sm text-background-50/60 leading-relaxed max-w-xs">
                O Hoobuy Spreadsheet é a lista mais completa e atualizada de
                produtos da China. Encontre os melhores preços e compre com
                segurança através de agentes confiáveis.
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 rounded-full border border-background-50/20 flex items-center justify-center hover:bg-background-50/10 transition-colors cursor-pointer"
                >
                  <i className="ri-global-line text-background-50/70 text-sm"></i>
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 rounded-full border border-background-50/20 flex items-center justify-center hover:bg-background-50/10 transition-colors cursor-pointer"
                >
                  <i className="ri-twitter-x-line text-background-50/70 text-sm"></i>
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 rounded-full border border-background-50/20 flex items-center justify-center hover:bg-background-50/10 transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-background-50/70 text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <p className="text-xs font-semibold text-background-50/40 uppercase tracking-wider mb-4">
                Categorias
              </p>
              <div className="space-y-2.5">
                {categories.slice(0, 7).map((cat) => (
                  <a
                    key={cat.nameEn}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="block text-sm text-background-50/60 hover:text-background-50/90 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <p className="text-xs font-semibold text-background-50/40 uppercase tracking-wider mb-4">
                Mais Categorias
              </p>
              <div className="space-y-2.5">
                {categories.slice(7, 14).map((cat) => (
                  <a
                    key={cat.nameEn}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="block text-sm text-background-50/60 hover:text-background-50/90 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <p className="text-xs font-semibold text-background-50/40 uppercase tracking-wider mb-4">
                Artigos
              </p>
              <div className="space-y-2.5">
                <Link
                  to="/artigo/guia-completo-hoobuy-spreadsheet"
                  className="block text-sm text-background-50/60 hover:text-background-50/90 transition-colors cursor-pointer"
                >
                  Guia Completo
                </Link>
                {articles.slice(0, 5).map((article) => (
                  <Link
                    key={article.slug}
                    to={`/artigo/${article.slug}`}
                    className="block text-sm text-background-50/60 hover:text-background-50/90 transition-colors cursor-pointer truncate"
                  >
                    {article.title}
                  </Link>
                ))}
              </div>
            </div>
          </div>

          <div className="border-t border-background-50/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; 2026 Hoobuy Sheet. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-6 flex-wrap justify-center">
              <Link
                to="/"
                className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors cursor-pointer"
              >
                Início
              </Link>
              <Link
                to="/artigo/guia-completo-hoobuy-spreadsheet"
                className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors cursor-pointer"
              >
                Guia de Compras
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors cursor-pointer"
              >
                Site Principal
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}